import {
    validationSchema,
    validationSchemaAza,
    validationSchemaBank,
    validationSchemaChaps,
    validationSchemaEGPBank,
    validationSchemaGHSBank,
    validationSchemaKESBank,
    validationSchemaNigeriaUSDBank,
    validationSchemaUSDBank,
    validationSchemaXBank,
    validationSchemaZARBank,
} from "./ValidationSchemas";
import {
    validationSchemaACH,
    validationSchemaBACS, validationSchemaBill, validationSchemaEFT,
    validationSchemaInterac
} from "../../BankTransferFormPersonal/FormHelpers/ValidationSchemas";
import * as yup from "yup";


export const getValidationSchema = (paymentTypeByRegion: string, paymentRegion: string) => {

    if (paymentRegion && paymentRegion !== "PAN AFRICA") {
        switch (paymentRegion) {
            case "ACH (only for USD)":
                return validationSchemaACH;
            case "BACS (only for GBP)":
                return validationSchemaBACS;
            case "INTERAC (only for CAD)":
                return validationSchemaInterac;
            case "EFT (only for CAD)":
                return validationSchemaEFT;
            case "Bill Payment (only for CAD)":
                return validationSchemaBill;
            case "CHAPS (only for GBP)":
                return validationSchemaChaps;
            case "FASTER PAYMENT (only for GBP)":
                return validationSchemaChaps;
            default:
                return validationSchema;
        }
    }

    if (paymentRegion === "PAN AFRICA") {
        switch (paymentTypeByRegion) {
            case "GHS::Bank":
                return validationSchemaGHSBank;

            case "EUR::Bank":
            case "GBP::Bank":
                return validationSchemaBank;

            case "XOF::Bank":
            case "XAF::Bank":
                return validationSchemaXBank;

            case "ZAR::Bank":
                return validationSchemaZARBank;

            case "USD::Bank":
                return validationSchemaUSDBank;

            case "KES::Bank":
                return validationSchemaKESBank;

            case "EGP::Bank":
                return validationSchemaEGPBank;

            case "NigeriaUSD::Bank":
                return validationSchemaNigeriaUSDBank;

            default:
                return validationSchemaAza;
        }
    }

    return validationSchema;

}

export const ValidationSchemaWithIgnore = (
    baseSchema: yup.ObjectSchema<any>,
    ignoreFields: string[] = []
): yup.ObjectSchema<any> => {
    let schema = baseSchema;

    ignoreFields.forEach(field => {
        schema = schema.shape({
            [field]: yup.mixed().notRequired(),
        });
    });

    return schema;
};
